import { render, staticRenderFns } from "./remove_images.vue?vue&type=template&id=3f803ba6&"
import script from "./remove_images.vue?vue&type=script&lang=js&"
export * from "./remove_images.vue?vue&type=script&lang=js&"
import style0 from "./remove_images.vue?vue&type=style&index=0&id=3f803ba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports